import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Row } from '@/components/Row';

export const Wrapper = styled(Row)`
  width: 100%;
  grid-gap: ${({ theme }) => theme.spacing(2)};
`;
export const Empty = styled(Flex)`
  margin-inline: auto;
  ${({ theme }) => css`
    ${theme.media.sm.up} {
      padding-top: ${({ theme }) => theme.spacing(4)};
      padding-bottom: ${({ theme }) => theme.spacing(3)};
    }
  `}
`;
